import xihuRoutes from '@/router/xihu'
import bameiRoutes from '@/router/bamei'
import bameiNewRoutes from '@/router/bameiNew'
import keqiRoutes from '@/router/keqi'
import shilinRoutes from '@/router/shilin'
import virtualTicketRoutes from '@/router/virtualTicket'
import shaoxingRoutes from '@/router/shaoxing'
import huangshanRoutes from '@/router/huangshan'
// 定制化页面配置信息
export default {
  730: {
    type: "huangshan",
    title: "黄山游览网",
    homeRoute: "huangShanHomePage",
    pageWidth: 1200,
    logo: require("../assets/images/huangshan/logo.png"),
    routes: huangshanRoutes
  },
  163: {
    type: "xihu",
    title: "西湖游览网",
    homeRoute: "xihuHomePage",
    pageWidth: 1200,
    logo: require("../assets/images/xihu/logo.png"),
    routes: xihuRoutes
  },
  9999: {
    type: "single",
    title: "西湖游览网",
    homeRoute: "xihuSingleCalendar",
    routes: xihuRoutes
  },
  // 1758
  // 1758: {
  //   type: "bamei",
  //   title: "坝美",
  //   homeRoute: "bameiHomePage",
  //   pageWidth: 1200,
  //   logo: require("../assets/images/bamei/logo.png"),
  //   routes: bameiRoutes
  // },
  // 新版
  1758: {
    type: "bamei",
    title: "坝美",
    homeRoute: "bameiNewHomePage",
    pageWidth: 1200,
    logo: require("../assets/images/bamei/logo@2x.png"),
    routes: bameiNewRoutes
  },
  1859: {
    type: "keqi",
    title: "克旗",
    homeRoute: "keqiHomePage",
    pageWidth: 1200,
    logo: require("../assets/images/keqi/克旗首页-2_04.png"),
    routes: keqiRoutes
  },
  2026: {
    type: "shilin",
    title: "石林",
    homeRoute: "shilHomePage",
    pageWidth: 1200,
    logo: require("../assets/images/shilin/logo.png"),
    routes: shilinRoutes
  },
  2072: {
    type: "virtualTicket",
    title: "虚拟票券核销",
    homeRoute: "virtualTicketHomePage",
    pageWidth: 1200,
    logo: require("../assets/images/shilin/logo.png"),
    routes: virtualTicketRoutes,
  },
  429: {
    type: "shaoxing",
    title: "绍兴",
    homeRoute: "shaoxingHomePage",
    pageWidth: 1200,
    logo: require("../assets/images/shilin/logo.png"),
    routes: shaoxingRoutes
  },
};



// WEBPACK FOOTER //
// ./src/common/privateServerConfig.js